module.exports = __webpack_public_path__ + "media/images/icons/main/zoom_in.svg-f81b8147eda2c1a7359a708ce7025a77.svg";